module.exports = __webpack_public_path__ + "static/ig-style-8c573d3e6abd2058581314704ab8fc12.mp4";